let eventTarget;
export default {
  components: {},
  props: {},
  data() {
    return {
      scenePlot_show: true,
      show: false,
      isFold: false,
    };
  },
  mounted() {
    eventTarget = new mars3d.BaseClass();
  },
  methods: {
    scenePlotBox_close() {
      this.$emit("scenePlotBox_close");
    },
    // 查看场景出图
    // viewScenePlot() {
    // 	this.$GLOBAL.map.expImage({
    // 		download: false,
    // 		callback: function(base64, size) {
    // 			// 回调
    // 			eventTarget.fire("loadOk", {
    // 				base64
    // 			})
    // 		}
    // 	})
    // },
    // 下载场景出图
    downloadScenePlot() {
      this.$GLOBAL.map.expImage();
    },
    // 下载场景缩略图
    downloadThumbnail() {
      this.$GLOBAL.map.expImage({
        height: 300, // 指定 高度 或 宽度(指定1种就行，对应的自动缩放)
        download: true,
      });
    },
  },
  watch: {},
  destroyed() {
    eventTarget = null;
  },
};
